import { render, staticRenderFns } from "./BetgameEditResultmode.vue?vue&type=template&id=2106299c&scoped=true"
import script from "./BetgameEditResultmode.vue?vue&type=script&lang=js"
export * from "./BetgameEditResultmode.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditResultmode.vue?vue&type=style&index=0&id=2106299c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2106299c",
  null
  
)

export default component.exports